import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import InsurancePriorityForm from './InsurancePriorityForm';

const InsurancePriorityModal = ({ show, onHide, insprvalue, edittrigger, onCallParent }) => {
    const isEdit = Boolean(insprvalue && (insprvalue.priority_id || insprvalue.insurancepriority_id || insprvalue.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Insurance Priority' : 'Add Insurance Priority'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <InsurancePriorityForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    insprvalue={insprvalue}
                />
            </Modal.Body>
        </Modal>
    );
};

InsurancePriorityModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    insprvalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default InsurancePriorityModal;
